module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.3e3c25f6.svg";